import { useAuthStore } from '@/store/authStore';

export function usePermission() {
  const user = useAuthStore(state => state.user);

  const can = (permissions: string | string[]): boolean => {
    if (!user || !user.permissions) return false;

    const requiredPermissions = Array.isArray(permissions)
      ? permissions
      : [permissions];

    if (requiredPermissions.length === 0) return true;

    return requiredPermissions.some(p => user.permissions?.includes(p));
  };

  return { can };
}
